export enum PumpType {
    verticalRight = 'Vertical - Right',
    verticalLeft = 'Vertical - Left',
    horizontalRight = 'Horizontal - Right',
    horizontalLeft = 'Horizontal - Left',
}

export const PUMP_ICON_BY_TYPE: Record<PumpType, string> = {
    [PumpType.verticalRight]: 'pump-vertical-right',
    [PumpType.verticalLeft]: 'pump-vertical-left',
    [PumpType.horizontalRight]: 'pump-horizontal-right',
    [PumpType.horizontalLeft]: 'pump-horizontal-left',
};
